export const Sizes = {
  breakPointSmall: '768px',
  breakPointXSmall: '340px',
  breakPoint: '1025px',
  breakPointMid: '590px',
  get breakPointDesktop() {
    return this.breakPoint;
  },
};
